<template>
  <Card
    :tag="tag"
    class="settings-card"
  >
    <CardSection v-if="title">
      <div
        class="settings-card--header"
        :class="{ 'settings-card--header-top': top }"
      >
        <div class="settings-card--header--heading">
          <h2 class="settings-card--header--title">
            {{ title }}
          </h2>
          <div
            v-if="description"
            class="settings-card--header--description"
          >
            {{ description }}
          </div>
        </div>

        <slot name="action" />
      </div>
    </CardSection>

    <template v-if="$slots['default']">
      <Separator
        v-if="title"
        color="float"
      />

      <CardSection class="settings-card--content">
        <slot />
      </CardSection>
    </template>
  </Card>
</template>

<script setup>
import Card from '@/components/ui/Card/Card.vue'
import CardSection from '@/components/ui/Card/CardSection.vue'
import Separator from '@/components/ui/Separator/Separator.vue'

defineOptions({ name: 'SettingsCard' })
defineProps({
  tag: { type: String, default: 'div' },
  title: { type: String, default: undefined },
  description: { type: String, default: undefined },
  top: { type: Boolean, default: false }
})
</script>

<style scoped>
@reference "#app-styles.css";

.settings-card {
  @apply w-full;

  .settings-card--content { @apply px-0 py-2; }
}

.settings-card--header {
  @apply flex items-center justify-between gap-4;

  &.settings-card--header-top { @apply items-start; }
}

.settings-card--header--title { @apply text-[14px] leading-6 font-medium; }
.settings-card--header--description { @apply text-[12px] leading-3.5 ink-subtle mt-0.5; }
</style>
